import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
/**
 * Generated class for the YearFilterPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'yearFilter',
})
export class YearFilterPipe implements PipeTransform {
  transform(values, filter, type?: string) {
    if (type === 'reports') {
      return values.filter(x => (filter === 'all' || moment(x['date']).get('year') === filter));
    } else {
      return values.filter(x => (filter === 'all' || x['year'] === filter));
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/year-filter/year-filter.ts